/* Popup newsletter Maison Mataha, dans ses deux régimes.

   Sur la boutique : ouverture après le délai réglé, puis mémoire de la vue en
   `localStorage` pour ne pas revenir avant `reshow_after_hours`, et plus jamais une fois
   le visiteur inscrit.

   Dans l'éditeur de thème : ni délai, ni mémoire, et ouverture pilotée par la sélection
   de la section dans la barre latérale. Sans cela la popup est invisible dès qu'on l'a
   vue une fois — la mémoire de vue s'appliquerait aussi à l'aperçu de l'éditeur, ce
   qui est exactement le symptôme remonté le 01/09 (« je n'arrive pas à la
   voir dans le thème »). Shopify en fait d'ailleurs une obligation : « you must make sure
   that when a section or block is selected, that section or block becomes, and remains,
   visible while it's selected ».

   Second point qui impose cette forme : l'éditeur re-rend la section à chaque réglage
   modifié et le JavaScript de chargement de page n'est PAS rejoué. Toute l'initialisation
   passe donc par `init()`, rappelée sur `shopify:section:load` — sinon la popup perdrait
   ses écouteurs (croix, Échap, piège de focus) à la première modification.

   Source : shopify.dev, « Integrate sections with the theme editor ». */
(() => {
  /* Le fichier peut être ré-évalué si l'éditeur réinjecte la balise `<script>` de la
     section. Les écouteurs posés sur `document` ci-dessous seraient alors doublés. */
  if (document.documentElement.dataset.mmNewsletterPopupPret === '1') return;
  document.documentElement.dataset.mmNewsletterPopupPret = '1';

  const enEditeur = Boolean(window.Shopify && window.Shopify.designMode);
  /* Les événements de l'éditeur ne transmettent qu'un `sectionId` : ce registre fait le
     lien avec les commandes de la popup correspondante, et il est reconstruit à chaque
     rendu de la section. */
  const registre = new Map();

  /* Navigation privée ou stockage refusé : la popup s'affiche, elle ne se souvient
     simplement de rien. */
  const lire = (zone, cle) => {
    try {
      return window[zone].getItem(cle);
    } catch (error) {
      return null;
    }
  };
  const ecrire = (zone, cle, valeur) => {
    try {
      window[zone].setItem(cle, valeur);
    } catch (error) {
      /* Idem : rien à mémoriser, rien à signaler. */
    }
  };
  const effacer = (zone, cle) => {
    try {
      window[zone].removeItem(cle);
    } catch (error) {
      /* Idem. */
    }
  };

  /* Shopify ne distingue pas les formulaires `customer` d'une même page :
     `form.posted_successfully?` et `customer_posted=true` suivent TOUT envoi réussi,
     y compris d'un formulaire qui n'est pas une newsletter, et le paramètre d'URL peut
     venir d'un lien partagé. Seul un envoi de CE visiteur, depuis un formulaire tagué
     `newsletter`, fait donc foi ; il est noté ici, avant le rechargement, dans la
     mémoire de l'onglet qui survit à l'aller-retour du formulaire. */
  const envoiKey = 'mm-newsletter-envoi';
  if (!enEditeur) {
    document.addEventListener('submit', (event) => {
      const formulaire = event.target;
      if (!formulaire.querySelector('input[name="contact[tags]"][value="newsletter"]')) return;
      ecrire('sessionStorage', envoiKey, formulaire.closest('[data-mm-newsletter-popup]') ? 'popup' : 'page');
    }, true);
  }

  const init = (popup) => {
    const dialog = popup.querySelector('.mm-newsletter-popup__dialog');
    if (!dialog) return;

    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const delai = Number(popup.dataset.openDelay || 0) * 1000;
    const showOnce = popup.dataset.showOnce === 'true';
    /* `sessionStorage` est cloisonné par ONGLET et vidé à la fermeture du navigateur : la
       popup revenait donc à chaque nouvel onglet et à chaque nouvelle visite, ce qui est
       le retour d'Alexia du 28/08 (PDF V3, remarque 1 : « il faudrait que le pop up
       n'apparaisse qu'une seule fois à l'ouverture du site et pas à chaque fois qu'on
       revient sur la page d'accueil »). La mémoire vit désormais dans `localStorage`,
       partagée entre les onglets et persistante, et porte la DATE de la vue pour que le
       délai de réaffichage soit réglable depuis l'éditeur plutôt que figé dans le code. */
    /* Demande de la cliente du 11/09 : une popup vue revient 24 heures après, et ne
       revient plus jamais une fois le visiteur inscrit. L'ancien délai de 30 jours
       rendait la popup « absente » pour toute personne l'ayant vue une fois. */
    const reshowHours = Number(popup.dataset.reshowHours || 24);
    /* Les clés ne portent PAS l'identifiant de la section. Celui-ci vaut
       `template--<id du template>__<clé de la section>` : il change dès qu'on duplique le
       thème ou qu'on republie, donc la popup serait revenue à chaque mise en ligne pour
       des visiteurs qui l'avaient déjà vue. */
    const storageKey = 'mm-newsletter-popup';
    const subscribedKey = 'mm-newsletter-popup-inscrit';

    /* Retour rendu par Shopify sur la page qui suit l'envoi, rapproché de l'envoi noté
       avant le rechargement. */
    const retour = popup.querySelector('[data-mm-popup-feedback]');
    const champ = popup.querySelector('input[type="email"]');
    /* L'envoi n'a de sens que sur la page qui le suit : il est consommé dès la lecture.
       Laissé en mémoire, un envoi abandonné serait rapproché d'un `customer_posted=true`
       arrivé plus tard par un lien partagé. */
    const envoi = enEditeur ? null : lire('sessionStorage', envoiKey);
    if (envoi) effacer('sessionStorage', envoiKey);
    const envoiReussi = retour?.dataset.mmPopupFeedback === 'success'
      || new URLSearchParams(window.location.search).get('customer_posted') === 'true';
    if (!enEditeur && ((envoi && envoiReussi) || popup.dataset.subscribed === 'true')) ecrire('localStorage', subscribedKey, '1');
    /* Le retour ne s'affiche dans la popup que si l'envoi venait d'elle. Un retour qui
       n'est pas le sien (lien partagé, section de la page) est retiré : sinon la popup
       s'ouvrirait plus tard sur un remerciement ou une erreur, formulaire masqué. */
    const retourAMontrer = envoi === 'popup' ? retour : null;
    if (retour && !retourAMontrer && !enEditeur) {
      retour.remove();
      champ?.removeAttribute('aria-invalid');
      champ?.removeAttribute('aria-describedby');
    }

    const estInscrit = () => lire('localStorage', subscribedKey) === '1';

    const dejaVue = () => {
      if (!showOnce) return false;
      const vueLe = Number(lire('localStorage', storageKey));
      /* Absente, illisible (`'true'`, écrit par une version précédente) ou dans le futur
         (horloge déréglée) : aucune date de vue fiable, la popup s'affiche et la date est
         reposée à ce moment-là. */
      if (!Number.isFinite(vueLe) || vueLe <= 0 || vueLe > Date.now()) return false;
      return Date.now() - vueLe < reshowHours * 3600000;
    };

    const marquerVue = () => {
      if (showOnce) ecrire('localStorage', storageKey, String(Date.now()));
    };

    let lastFocus = null;
    let timerOuverture = null;
    let timerMasquage = null;

    const close = () => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mm-newsletter-popup-open');
      window.clearTimeout(timerOuverture);
      window.clearTimeout(timerMasquage);
      /* `hidden` n'est reposé qu'à la fin du fondu. Le timer est gardé pour pouvoir
         l'annuler si la popup est rouverte entre-temps, sans quoi elle se masquerait
         toute seule juste après avoir été rouverte — enchaînement courant dans l'éditeur,
         où sélection et désélection se suivent de près. */
      timerMasquage = window.setTimeout(() => {
        popup.hidden = true;
      }, 260);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    const open = (forcer, cibleFocus = dialog) => {
      if (!forcer && (estInscrit() || dejaVue())) return;
      /* Tiroir panier ouvert : il rend la page inerte, fenêtre comprise. Ouverte par-dessus,
         la fenêtre restait intouchable et sa croix actionnait le tiroir caché dessous (un
         parfum retiré du panier, audit du 27/09/2026). Elle attend la fermeture du tiroir. */
      const tiroir = document.querySelector('cart-drawer');
      if (!forcer && !enEditeur && tiroir && tiroir.classList.contains('is-open')) {
        const attente = new MutationObserver(() => {
          if (tiroir.classList.contains('is-open')) return;
          attente.disconnect();
          window.setTimeout(() => open(false, cibleFocus), 800);
        });
        attente.observe(tiroir, { attributes: true, attributeFilter: ['class'] });
        return;
      }
      window.clearTimeout(timerMasquage);
      lastFocus = document.activeElement;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      /* Le verrou de défilement ne vaut que pour la boutique : dans l'éditeur, une popup
         fermée autrement que par la barre latérale laisserait le `body` bloqué et
         l'aperçu paraîtrait cassé. */
      if (!enEditeur) document.body.classList.add('mm-newsletter-popup-open');
      requestAnimationFrame(() => {
        popup.classList.add('is-open');
        cibleFocus.focus();
      });
      /* L'aperçu de l'éditeur ne consomme pas la mémoire de vue du visiteur. */
      if (!enEditeur) marquerVue();
    };

    popup.querySelectorAll('[data-mm-popup-close]').forEach((closer) => closer.addEventListener('click', close));
    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      /* Seuls les éléments rendus comptent : après une inscription le formulaire est
         masqué en CSS, et `focus()` sur un élément masqué ne fait rien, le piège ne
         bouclait donc plus. */
      const focusable = [...dialog.querySelectorAll(focusableSelector)]
        .filter((element) => element.getClientRects().length > 0);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (!enEditeur) {
      /* Après un envoi, la popup se rouvre aussitôt pour montrer le remerciement ou
         l'erreur : sans cela, le visiteur rechargeait la page sans aucun retour. */
      if (retourAMontrer) {
        /* Sur une erreur, le focus va au champ à corriger, qui porte déjà le message ;
           sur un succès, le panneau reçoit le focus et se décrit par le remerciement. */
        if (retourAMontrer.dataset.mmPopupFeedback === 'error' && champ) {
          open(true, champ);
          return;
        }
        dialog.setAttribute('aria-describedby', retourAMontrer.id);
        open(true);
        return;
      }
      /* Les images de la popup sont en `loading="lazy"` : popup masquée, le navigateur ne
         les demandait qu'à l'ouverture, d'où un fond vide (texte alternatif affiché) pendant
         une seconde environ. Le téléchargement démarre donc pendant le délai d'ouverture,
         et seulement pour un visiteur à qui la popup va vraiment s'afficher. */
      if (!estInscrit() && !dejaVue()) {
        /* Mise à jour du 26/09/2026 : le téléchargement part 1,5 s avant l'ouverture et non
           plus tout de suite, pour laisser la bande passante du début au premier écran
           (120 Ko en mobile d'après PageSpeed). L'image est prête quand la popup s'ouvre. */
        window.setTimeout(() => {
          popup.querySelectorAll('img[loading="lazy"]').forEach((image) => { image.loading = 'eager'; });
        }, Math.max(0, delai - 1500));
      }
      timerOuverture = window.setTimeout(() => open(false), delai);
      return;
    }

    registre.set(popup.dataset.sectionId, { popup, open: () => open(true), close });
    /* Réglage « Garder la popup ouverte dans l'éditeur » : la popup s'affiche sans
       attendre qu'on sélectionne sa section, pour pouvoir la régler en la voyant. */
    if (popup.dataset.editorPreview === 'true') open(true);
  };

  const boot = (scope) => scope.querySelectorAll('[data-mm-newsletter-popup]').forEach(init);

  boot(document);
  document.addEventListener('shopify:section:load', (event) => boot(event.target));

  if (!enEditeur) return;

  const commandes = (event) => registre.get(event.detail.sectionId);

  document.addEventListener('shopify:section:select', (event) => commandes(event)?.open());
  document.addEventListener('shopify:section:deselect', (event) => {
    const entree = commandes(event);
    if (!entree) return;
    /* La popup reste ouverte si la marchande a demandé l'aperçu permanent ; la croix et
       la touche Échap la ferment dans tous les cas. */
    if (entree.popup.dataset.editorPreview === 'true') return;
    entree.close();
  });
  document.addEventListener('shopify:section:unload', (event) => registre.delete(event.detail.sectionId));
})();
